/** 첨부 확장자를 사람이 읽을 순서로. 중복은 접는다 — `png · png · png` 는 정보가 아니다. */
function extList(attachments) {
    return [...new Set(attachments.map((a) => a.ext ?? '?'))].join(' · ');
}
/** 제목 옆의 한 줄. 무엇을 읽었고 왜 못 읽었는지. */
export function noticeStatusNote(g) {
    switch (g.textStatus) {
        case 'ok':
            // 형식(pdf·hwp)은 원문 탭이 말한다. 여기는 이 탭이 무엇인지 — 추출한 텍스트다.
            return `추출 · ${g.noticeWords?.toLocaleString('ko-KR')}단어`;
        case 'no_file':
            // 첨부 배열이 비었을 때만 온다. 이때만 이 말을 할 자격이 있다.
            return '첨부 없음';
        case 'unreadable':
            // 첨부는 있다. 우리가 못 여는 것뿐이니 **몇 개가 무슨 형식인지** 밝힌다.
            return `첨부 ${g.attachments.length}개 (${extList(g.attachments)}) — 이미지라 아직 못 읽음`;
        case 'no_text':
            // **추측하지 말고 사실만.** 글자가 하나도 없으면 스캔이라고 볼 근거가
            // 있지만, 46단어짜리 안내문을 「스캔 문서」라고 부르면 틀린다 — 실제로
            // 그런 공고가 있었다 (포스터 png + 46단어 txt).
            return g.noticeWords
                ? `${g.noticeExt} · ${g.noticeWords.toLocaleString('ko-KR')}단어 — 전문이 짧습니다`
                : `${g.noticeExt} · 글자 없음 — 스캔 문서로 보임`;
        case 'failed':
            return '추출 실패 — 재시도 대상';
        default:
            return '아직 읽지 않음';
    }
}
/** 본문이 없을 때 본문 자리에 놓는 말. 독자가 다음에 할 일을 알려준다. */
export function noticeEmptyNote(g) {
    switch (g.textStatus) {
        case 'no_file':
            return '이 공고에는 첨부가 없습니다. 아래 원문 링크에서 확인해 주세요.';
        case 'unreadable':
            return '첨부가 이미지라 아직 글자로 옮기지 못했습니다. 아래 첨부 목록에서 바로 받아 보실 수 있습니다.';
        case 'no_text':
            return '첨부를 열었지만 글자가 없습니다 — 스캔 문서로 보입니다. 아래 첨부에서 원본을 확인해 주세요.';
        case 'failed':
            return '공고문을 받지 못했습니다. 곧 다시 시도합니다.';
        default:
            return '공고문을 아직 읽지 않았습니다.';
    }
}
/**
 * 목록 첫 열.
 *
 * **이 자리에 금액을 두지 않는다.** 지금 단계에서 목록이 답해야 하는 질문은
 * 「얼마인가」가 아니라 **「이 공고문을 글자로 만들었는가」**다. 금액 판정은
 * 이 저장소가 하지 않고 별도 프로그램이 `/internal` 계약으로 한다 — 그전까지
 * 금액 칸을 두면 7,600행 전부가 「확인 중」인 죽은 열이 된다.
 *
 * 파서가 지나간 뒤에는 **몇 자를 얻었는지** 숫자로 말한다. 상태 이름보다
 * 숫자가 정확하다: `46자` 는 「스캔 문서로 보임」 같은 추측을 하지 않으면서도
 * 그 공고에 읽을 게 거의 없다는 사실을 그대로 전한다.
 */
/**
 * **공개 목록은 더 이상 이걸 쓰지 않는다.** 카드 첫 열은 해석된 지원 요약이
 * 차지한다 (`grant-support-view.ts`). 자수는 우리 배치가 얼마나 읽었는지이지
 * 독자가 알고 싶은 것이 아니다. 진단용으로 남긴다.
 */
export function extractionLabel(g) {
    if (g.textStatus === null)
        return '확인중';
    if (g.noticeChars)
        return `${g.noticeChars.toLocaleString('ko-KR')}자`;
    switch (g.textStatus) {
        case 'no_file':
            return '첨부 없음';
        case 'unreadable':
            return '이미지 공고문';
        case 'failed':
            return '추출 실패';
        default:
            return '글자 없음';
    }
}
//# sourceMappingURL=notice-status.js.map